import { fileRequest } from "./fileRequest";

export default fileRequest;
